import { useState, useEffect } from 'react';

const BREAKPOINT_PHONE = 576;  // px
const BREAKPOINT_TABLET = 768; // px
const BREAKPOINT_LAPTOP = 1024; // px

export function useWindowSize() {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : BREAKPOINT_TABLET + 1
  );

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return {
    width,
    isPhone: width < BREAKPOINT_PHONE,
    isTablet: width >= BREAKPOINT_PHONE && width <= BREAKPOINT_TABLET,
    isLaptop:  width >= BREAKPOINT_TABLET && width < BREAKPOINT_LAPTOP,
    isDesktop: width >= BREAKPOINT_LAPTOP,
  };
}
